<template>
    <v-card>
        <v-card-title class="headline grey darken-4">
            Informar Telefone do Cliente
            <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="pt-4">
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <Input v-model="phone" mask="(##) #####-####" @keydown.enter="checkPhone" />
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions } from "vuex";

    export default {
        data() {
            return {
                phone: "",
            };
        },
        methods: {
            ...mapActions("customer", ["showByPhone", "showByCard"]),
            ...mapActions("print", ["printCustomerQR"]),

            validatePhone(phone) {
                const cleanedPhone = phone.replace(/[^\d]+/g, '');
                // Validação básica: verifica se tem 10 ou 11 dígitos (comum no Brasil)
                return cleanedPhone.length === 10 || cleanedPhone.length === 11;
            },

            checkPhone() {
                if (!this.validatePhone(this.phone)) {
                    this.$toast.error("Telefone inválido. Verifique o formato.");
                    return;
                }
                const cleanedPhone = this.phone.replace(/[^\d]+/g, '');
                this.showByPhone(cleanedPhone).then((response) => {
                    if (response.data.id) {
                        this.printCustomerQR(response.data.id);
                        this.$emit('close-dialog');
                    }

                }).catch(error => {
                    this.$toast.error("Cliente não encontrado com este telefone.");
                }).finally(() => {
                    this.phone = "";
                    this.showByCard(1)
                });
            },
        },
    };
</script>
